import { Field } from 'redux-form';
import { createTextMask, createNumberMask } from 'redux-form-input-masks';

import { SourceInput } from './source-input';

/*
const maxDatePeriod = 3;
const maxDatePeriodType = 'months';

const checkPeriod = (t, name) => (_val, row) => {
  let error = undefined;

  const fn1 = name.split('_');
  if (fn1.length !== 2) {
    return error;
  }
  const fn = fn1[0];
  const fn_from = fn + '_from';
  const fn_to = fn + '_to';
  if (!row[fn_from] || !row[fn_to]) {
    return error;
  }

  const d1 = moment(row[fn_from]);
  const d2 = moment(row[fn_to]);
  if (d2 <= d1) {
    error = t('messages.Дата начала периода больше даты конца периода');
  } else if (d2.subtract(maxDatePeriod, maxDatePeriodType) > d1) {
    error = t('messages.Период не должен превышать три месяца');
  }
  return error;
};
*/

export const FieldComponent = (props) => {
  const { mask, tabIndex, autoFocus, onChange, ...rest } = props;
  // const { t, i18n } = useTranslation();
  // const isDateTime = props.type === 'dateTime' && (props.name?.includes('_from') || props.name?.includes('_to'));
  let textMask = null;
  let numberMask = null;

  switch (typeof mask) {
    case 'string':
      textMask = createTextMask({
        pattern: props.mask,
        stripMask: !props.storeWithMask,
      });
      break;
    case 'object':
      numberMask = createNumberMask({
        ...mask,
        allowNegative: !!rest.withMinus,
      });
      break;
    default:
      break;
  }
  let numberNormalize = numberMask ? numberMask.normalize : undefined;
  // let numberValidate = numberMask ? numberMask.validate : undefined;
  if (numberMask) {
    delete numberMask.normalize;
    delete numberMask.validate;
  }

  const validate = props.validate;

  const prepareNaturalNumber = (value, previous) => {
    // console.log("value", value);
    const fractional = props.fractional;

    if (props.naturalNumber) {
      // 9 999 руб
      // we need to remove letters
      value = value.replace(/[^0-9.+-]|(?<=\..*)\./g, '');

      // zero
      if (props.withZero) {
        if (!value) {
          if (props.EmptyOnExit) {
            return '';
          }
          return 0;
        }
        let out = value.replace(/[^\d]/g, '');
        const negative = props.withMinus && value.startsWith('-');
        if (!out.trim()) {
          if (negative) {
            return '-';
          }
          if (props.EmptyOnExit) {
            return '';
          }
          return 0;
        }
        return negative ? `-${parseInt(out)}` : parseInt(out);
      }
      // minus
      if (props.withMinus) {
        if (!value) {
          return 0;
        }

        if (fractional) {
          // [+-]?([0-9]*[.])?[0-9]+
          // [+-]?\d+(\,\d+)?
          // const numbers = value.match(/(^[+-]?([0-9]*[,])?[0-9]+$)/g);
          // console.log('🚀 ~ normalize ~ numbers:', numbers);
          // if (!numbers?.length) {
          //   return 0;
          // }
          // const out = numbers[0].replace(',', '.');
          // return out[out.length - 1] === '.' ? out : parseFloat(out);
          return value
            .replace(',', '.')
            .replace(/[^0-9.+-]|(?<=\..*)\./g, '')
            .replace(/^0+/, '0')
            .replace(/^0(?=[1-9])/, '');
        }

        const numbers = value.match(/([+-]?\d+)/g);
        return numbers && numbers.length ? parseInt(numbers[0]) : 0;
      }

      const testZero = value.replace(/[^\d]/g, '').replace(/^0+(?=[1-9])/g, '');
      if (!testZero || /^0+$/g.test(testZero)) {
        if (!props.min) {
          return '';
        }
        let out = testZero ? Number(testZero) : 0;
        if (out < props.min) {
          // out = previous ?? props.min;
          return undefined;
        }
        return out.toString();
      } else {
        let out = value.replace(/[^\d]/g, '').replace(/^0+(?=[1-9])/g, '');
        if (out) {
          out = Number(out);
          if (props.min) {
            if (out < props.min) {
              out = previous ?? props.min;
            }
          }
          if (props.max) {
            if (out > props.max) {
              out = previous ?? props.max;
            }
          }
        }
        return out;
      }
    }
  };

  const normalize = (value, previous) => {
    // props.type
    // console.log("value", value);
    if (props.type !== 'text' && props.type !== 'number') {
      return value;
    }
    // console.log("props.type", props.type);
    // console.log('normalize', value);
    if (props.withoutLetters) {
      value = value.replace(/\D/g, '');
    } else if (value.length > props.maxValueLength) {
      value = value.substring(0, value.length - 1);
    } else {
      if (props.naturalNumber) {
        value = prepareNaturalNumber(value, previous);
      } else if (props.withoutSpaces) {
        value = value.replace(/[\s]/g, '');
      }
    }

    if (!numberMask) {
      return value ? value.toString() : '';
    }
    // console.log("numberNormalize", value);

    return numberNormalize(value ? value.toString() : '');
  };

  const other = {};
  // const name = props.name;
  // if (isDateTime && !props.validate) {

  //   other.validate = useCallback(checkPeriod(t, name), [t, name]);
  //   other.simpleErrorWrapper = true;
  //   other.asFilter = true;
  // }
  // if (numberMask) {
  //   console.log('textMask', numberMask, rest, other);
  // }

  return (
    <Field
      tabIndex={tabIndex}
      autoFocus={autoFocus}
      component={SourceInput}
      additionalComponent={props.additionalComponent}
      className={props.className}
      Tip={props.tip}
      name={props.name}
      label={props.label}
      placeholder={props.placeholder}
      type={props.type}
      disabled={props.disabled}
      value={props.value}
      data={props.data}
      normalize={normalize}
      withoutWrapper={props.withoutWrapper}
      maxLength={props.maxLength}
      // need for autocomplete field
      getList={props.getList}
      setAutocompleteList={props.setAutocompleteList}
      requestParams={props.requestParams}
      // need for date field
      withoutIcon={props.withoutIcon}
      // need for zone field
      countDisplayedIcons={props.countDisplayedIcons}
      maxValuesShow={props.maxValuesShow}
      onChangeInput={onChange}
      onChange={onChange}
      //ref={props.ref}
      //withRef={props.withRef}
      // mask={props.mask}
      validate={validate}
      {...textMask}
      {...numberMask}
      {...rest}
      {...other}
    >
      {props.children}
    </Field>
  );
};
